<script setup lang="ts">
import SettingsLayout from '../features/settings/SettingsLayout.vue';
</script>

<template>
  <SettingsLayout />
</template>
